import { render } from "./App.vue?vue&type=template&id=811d622e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=811d622e&lang=css"

import exportComponent from "C:\\Users\\chas\\Documents\\Shep\\shep-landing-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__